import Vue from 'vue';

import * as TouchClass from './touch-class';

Vue.directive('touch-class', TouchClass);



// WEBPACK FOOTER //
// ./src.common/uikit/directives/index.js